import React, { Component } from 'react'
import PropTypes from 'prop-types'
import BundleSummary from './BundleSummary'
import BundleItem from './BundleItem'

import * as Styled from './Bundle.styles'

class Bundle extends Component {
  createAnalyticsOptions = () => {
    const { bundleId, items, partNumber, price, productName, index } = this.props
    return {
      bundleId,
      bundleItems: {
        main: {
          id: partNumber,
          price: price && price.now,
          quantity: 1,
          name: productName
        },
        additional: items.map(item => ({
          id: item.id,
          price: item.price,
          quantity: 1,
          name: item.name
        }))
      },
      bundleType: 'fbtBundle',
      bundleSize: items.length + 1,
      bundlePlacement: `P${index + 1}`
    }
  }

  render() {
    const { partNumber, price, items, productName } = this.props
    const currentProductData = { id: partNumber, name: productName }
    const containerClass = 'xs-row deal bundle'
    const detailsClass = 'xs-12--none md-8--none deal__details'

    const bundleItemsData = [currentProductData, ...items]
    const createBundleItem = (item, key) => <BundleItem {...{ item, key, currentProduct: partNumber }} />
    const bundleItems = bundleItemsData.map(createBundleItem)

    const { createAnalyticsOptions } = this
    return (
      <BundleContainer className={containerClass}>
        <BundleDetails className={detailsClass}>{bundleItems}</BundleDetails>
        <BundleSummary {...{ partNumber, price, items, analyticsOptions: createAnalyticsOptions() }} />
      </BundleContainer>
    )
  }
}

Bundle.propTypes = {
  bundleId: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  partNumber: PropTypes.string.isRequired,
  price: PropTypes.object.isRequired,
  productName: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired
}

const BundleDetails = ({ children, className }) => <div className={className}>{children}</div>

const BundleContainer = ({ children, className }) => (
  <Styled.BundleContainer className={className}>{children}</Styled.BundleContainer>
)

export default Bundle
